module.exports = ({
    "CDMS600MSG001": "คุณแน่ใจหรือไม่ว่าต้องการปิด Query ที่เลือกไว้?",
    "CDMS600MSG002": "กรุณากรอกเนื้อหา Query",
    "CDMS600MSG003": "คุณแน่ใจหรือไม่ว่าต้องการเปิด Query ที่เลือกไว้ใหม่?",
    "CDMS600MSG004": "คุณแน่ใจหรือไม่ว่าต้องการแก้ไขเนื้อหาของ Query ที่เลือกไว้?",

    "CDMS600BTN001": "ประมวลผลเป็นกลุ่ม (Batch Process)",
    "CDMS600BTN002": "ดำเนินการ",

    "CDMS600H001": "หมายเลข",
    "CDMS600H002": "ชื่อสถานวิจัย",
    "CDMS600H003": "รหัสผู้เข้าร่วมวิจัย",
    "CDMS600H004": "Visit",
    "CDMS600H005": "Page",
    "CDMS600H006": "Block",
    "CDMS600H007": "Line No.",
    "CDMS600H008": "รายการ",
    "CDMS600H009": "สถานะ",
    "CDMS600H010": "ประเภท Query",
    "CDMS600H011": "รายละเอียด Query",
    "CDMS600H012": "รายละเอียดคำตอบ",
    "CDMS600H013": "ผู้สร้าง",
    "CDMS600H014": "วันที่และเวลาที่แก้ไขล่าสุด",

    "CDMS600TT001": "การจัดการ Query",
    "CDMS600TT002": "ประมวลผลเป็นกลุ่ม (Batch Process)",

    "CDMS600OPT001": "ปิด Query",
    "CDMS600OPT002": "เปิด Query ใหม่",
    "CDMS600OPT003": "แก้ไข Query",
    "CDMS600OPT004": "Open",
    "CDMS600OPT005": "Closed",
    "CDMS600OPT006": "Answered",
    "CDMS600OPT007": "System",
    "CDMS600OPT008": "Manual",
    "CDMS600OPT009": "ระบบ",
});